export default (url) => {
  url.match(
    /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
  );
  if (RegExp.$3.indexOf('youtu') > -1) {
    return {
      type: 'youtube',
      id: RegExp.$6,
    };
  }
  if (RegExp.$3.indexOf('vimeo') > -1) {
    return {
      type: 'vimeo',
      id: RegExp.$6,
    };
  }
  return {
    type: 'other',
    id: null,
  };
};